<template>
  <div class="l-container DocumentIndex">

    <template v-if="!edit.edit">
      <button @click="deleteDocument">delete</button>
      <button @click="switchDocument">edit</button>
      
      <div class="index-box">
        <div class="header">
          <template v-if="calcUser_id">
            <p>user: {{ calcUser_id.user }}</p>
          </template>
      
          <template v-if="document.office_id">
            <p>office: {{ calcOffice_id }}</p>
          </template>
          <template v-else>
            <p>office: admin</p>
          </template>
      
          <p>created: {{ calcCreated_at }}</p>
          <p>updated: {{ calcUpdated_at }}</p>
        </div>
      
        <div class="main">
          <div class="title">{{setCategory.name}}</div>
          <div class="title">{{document.title}}</div>
          <div class="vue-html" v-html="document.note"></div>
        </div>
      </div>
    </template>

    <template v-else>
      <button @click="switchDocument">cancel</button>
      <button @click="patchDocument">update</button>
      
      <div class="index-box">
        <div class="header">
          <template v-if="calcUser_id">
            <p>user: {{ calcUser_id.user }}</p>
          </template>
      
          <template v-if="document.office_id">
            <p>office: {{ calcOffice_id }}</p>
          </template>
          <template v-else>
            <p>office: admin</p>
          </template>
      
          <p>created: {{ calcCreated_at }}</p>
          <p>updated: {{ calcUpdated_at }}</p>
        </div>
      
        <div class="main">
          <select v-model="document.category" class="select">
            <option v-for="(list, index) in category" :key="index" :value="list.value">{{ list.name }}</option>
          </select>
          <input class="title" type="text" v-model="document.title" placeholder="title">
          <vue-html5-editor @change="patchNote(document, $event)" :content="document.note" :auto-height="true"></vue-html5-editor>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
export default {
  props: {
    // xxx: Object
  },
  data () {
    return {
      edit: {
        edit: false
      }
    }
  },
  computed: {
    document () {
      return this.$store.getters.document
    },

    category () {
      return this.$store.getters['documents/category']
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    offices () {
      return this.$store.getters.offices
    },

    calcUser_id () {
      if (this.document.user_id) {
        return this.users.filter(item => {
          return item.id === this.document.user_id
        })[0]
      } else {
        return
      }
    },

    calcOffice_id () {
      if (this.document.office_id) {
        return this.offices.filter(item => {
          return item.id === this.document.office_id
        })[0].name
      } else {
        return 'admin'
      }
    },

    calcCreated_at () {
      const datetime = new Date(this.document.created_at)
      const year = datetime.getFullYear()
      let month = datetime.getMonth() + 1
      month = month.toString()
      month = month.padStart(2, '0')
      let date = datetime.getDate()
      date = date.toString()
      date = date.padStart(2, '0')
      let hours = datetime.getHours()
      hours = hours.toString()
      hours = hours.padStart(2, '0')
      let minutes = datetime.getMinutes()
      minutes = minutes.toString()
      minutes = minutes.padStart(2, '0')
      return year + '/' + month + '/' + date + ' ' + hours + ':' + minutes
    },

    calcUpdated_at () {
      const datetime = new Date(this.document.updated_at)
      const year = datetime.getFullYear()
      let month = datetime.getMonth() + 1
      month = month.toString()
      month = month.padStart(2, '0')
      let date = datetime.getDate()
      date = date.toString()
      date = date.padStart(2, '0')
      let hours = datetime.getHours()
      hours = hours.toString()
      hours = hours.padStart(2, '0')
      let minutes = datetime.getMinutes()
      minutes = minutes.toString()
      minutes = minutes.padStart(2, '0')
      return year + '/' + month + '/' + date + ' ' + hours + ':' + minutes
    },

    setCategory: {
      get () {
        return this.calcCategory(this.document.category)
      },
      set (newValue) {
        this.document.category = this.calcCategory(newValue)
      }
    }
  },

  watch: {
  },

  methods: {
    switchDocument () {
      this.edit.edit = !this.edit.edit
    },

    patchNote (document, $event) {
      document.note = $event
      console.log($event)
      console.log(document)
    },

    calcCategory (val) {
      if (toString.call(val) === '[object Number]') {
        let obj = this.category[val]
        return obj
      } else if (toString.call(val) === '[object Object]') {
        return val
      }
    },

    getDocument (id) {
      this.$store.dispatch('getDocument', {
        id: id
      })
    },

    deleteDocument () {
      this.$store.dispatch('deleteDocument', {
        this: this,
        document: this.document
      })
    },

    patchDocument () {
      this.$store.dispatch('patchDocument', {
        this: this,
        document: this.document,
        edit: this.edit
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    next()
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss' scoped>
.header {
  display: flex;
  padding: 5px;
  p {
    padding: 5px;
    margin: 0;
    color: #37474f;
  }
}
.main {
  padding: 5px;
}
.index-box {
  height: calc(100vh - 130px);
  overflow: scroll;
  margin-top: 10px;
  /* &:after { */
  /*   content: "\f040"; */
  /*   font-family: FontAwesome; */
  /*   position: absolute; */
  /*   font-size: 250px; */
  /*   top: 50%; */
  /*   left: 50%; */
  /*   margin-top: -125px; */
  /*   margin-left: -125px; */
  /*   color: #ddd; */
  /*   opacity: 0.1; */
  /*   z-index: -1; */
  /* } */
}
.title {
  width: 100%;
  padding: 10px 10px 5px 10px;
  outline: 0;
  font-size: 20px;
  font-weight: bold;
  border: none;
  border-bottom: 1px solid #e1e2e1;
}
.select {
  outline: 0;
}
.vue-html {
  line-height: 1.8;
  text-align: justify;
  padding: 10px;
}
.vue-html5-editor {
  border: none !important;
  .toolbar ul {
    padding: 0;
  }
  /* 効かない */
  /* .content { */
  /*   height: calc(100vh - 348px) !important; */
  /* } */
}
</style>



// WEBPACK FOOTER //
// DocumentIndex.vue?4ce90833